import { Avatar, Icon, Text, HStack, Stack, SuitabilityBadge, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { CustomerWalletPoints } from '../../../../../components/CustomerWalletPoints';
import { MultipleAccountsSelection } from '../../../../../components/MultipleAccountsSelection';

import { BlockStatusTooltip } from './components/BlockStatusTooltip';

import { InfoPanelTypes } from '.';

export const Info: React.FC<InfoPanelTypes.Props & { otherFields?: boolean }> = ({
  customer,
  isLoading,
  otherFields,
  accountSelected,
  handleChangeAccount,
}) => {
  return (
    <VStack space="stack.xxs">
      <HStack space="stack.nano" alignItems="center">
        {!isLoading && customer ? (
          <SuitabilityBadge
            label={customer.investorProfile.suitabilityNormalized}
            hideText
            withTooltip
          />
        ) : (
          <Avatar
            testId="avatar"
            isLoading
            bgColor="backgroundlight"
            initials="LO"
            textColor="background"
          />
        )}
        <VStack space="stack.quarck" flex={1}>
          <Text isLoading={isLoading} variant="semibold">
            {customer?.personalInformation.fullNameNormalized}
          </Text>
          <Text isLoading={isLoading} fontSize="xs" color="neutral.medium" variant="semibold">
            {customer?.personalInformation.emailNormalized}
          </Text>
        </VStack>
        {!otherFields && (
          <VStack space="stack.quarck">
            <Avatar
              testId="suitability-avatar"
              isLoading={isLoading}
              bgColor={customer?.investorProfile.suitabilityColorNormalized ?? 'background'}
              textColor="neutral.white"
              initials={'BRASIL'}
            />
          </VStack>
        )}
      </HStack>
      {otherFields && (
        <VStack space="stack.nano">
          <HStack justifyContent="space-between" space="inline.quarck">
            <VStack space="stack.quarck" flex={1}>
              <Text>Conta de custódia</Text>
              {customer && !isLoading ? (
                <MultipleAccountsSelection
                  isMobile
                  accounts={customer.additionalAccounts}
                  accountSelected={accountSelected}
                  setAccountSelected={handleChangeAccount}
                />
              ) : (
                <Text isLoading w="full" />
              )}
            </VStack>
            <VStack space="stack.quarck" flex={1}>
              <Text alignSelf="flex-end">Cadastro</Text>
              <Stack alignSelf="flex-end" w="full">
                <BlockStatusTooltip customer={customer} isLoading={isLoading}>
                  <HStack
                    alignItems="center"
                    justifyContent="flex-end"
                    space="stack.quarck"
                    w="full">
                    <Text isLoading={isLoading} w={isLoading ? 'full' : undefined}>
                      {customer?.accountAndEarnings.statusNormalized.textNormalized}
                    </Text>
                    {!isLoading && customer && (
                      <Icon
                        testID="account-status-icon"
                        name={customer?.accountAndEarnings.statusNormalized.iconNormalized}
                        size={customer?.accountAndEarnings.statusNormalized.iconSizeNormalized}
                        color={customer?.accountAndEarnings.statusNormalized.iconColorNormalized}
                      />
                    )}
                  </HStack>
                </BlockStatusTooltip>
              </Stack>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between" space="inline.quarck">
            <VStack space="stack.quarck" flex={1}>
              <Text>Disp. para investir</Text>
              <Text isLoading={isLoading}>
                {Utils.Mask.Money(customer?.accountAndEarnings.availableToInvest)}
              </Text>
            </VStack>
            <VStack space="stack.quarck" flex={1}>
              <Text alignSelf="flex-end">Patrimônio total</Text>
              <Text isLoading={isLoading} alignSelf="flex-end">
                {customer?.accountAndEarnings.totalNetWorthNormalized}
              </Text>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between" space="inline.quarck">
            <VStack space="stack.quarck" flex={1}>
              <Text>Saldo em conta</Text>
              <Text isLoading={isLoading}>
                {' '}
                {Utils.Mask.Money(customer?.accountAndEarnings.availableBalance)}
              </Text>
            </VStack>
            <VStack space="stack.quarck" flex={1}>
              <Text alignSelf="flex-end">Pts da carteira</Text>
              {!isLoading && customer ? (
                <HStack justifyContent="flex-end" w="full">
                  <CustomerWalletPoints
                    preventPadding
                    accountNumber={customer.additionalAccounts[0]?.accountNumber}
                  />
                </HStack>
              ) : (
                <Text isLoading={isLoading} />
              )}
            </VStack>
          </HStack>
        </VStack>
      )}
    </VStack>
  );
};
